var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "15-refund",
    fill: "#ff4d4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.865 240h14.27L248 218.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 88H40a40.045 40.045 0 0 0-40 40v224a40.045 40.045 0 0 0 40 40h88v-32H40a8.009 8.009 0 0 1-8-8V128a8.009 8.009 0 0 1 8-8h432a8.009 8.009 0 0 1 8 8v224a8.009 8.009 0 0 1-8 8H274.161l18.131-21.757-24.584-20.486-40 48a16 16 0 0 0 0 20.486l40 48 24.584-20.486L274.161 392H472a40.045 40.045 0 0 0 40-40V128a40.045 40.045 0 0 0-40-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 344V136H48v208h177.012l40.648-48.778 49.166 40.978-6.5 7.805zM192 208h-32v80h-32v-80H96v-32h96zm80.821 85.06L265.8 272h-35.6l-7.02 21.06-30.358-10.12 32-96A16 16 0 0 1 240 176h16a16 16 0 0 1 15.179 10.94l32 96zm42.887-98.817 24.584-20.486L368 207.007l27.708-33.25 24.584 20.486L388.827 232l31.465 37.757-24.584 20.486L368 256.993l-27.708 33.25-24.584-20.486L347.173 232z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/Tax.4f2f3cb858721b85bedd16ae4504d5bc.svg";
export { ForwardRef as ReactComponent };